export default __webpack_public_path__ + "static/media/abstract6.2cae6df2.jpg";